import { message } from 'antd';

export const showSuccessMessage = (msg) => {
  if (msg) {
    message.success(msg);
  }
};

export const showWarningMessage = (msg) => {
  if (msg) {
    message.warning(msg);
  }
};
